import React, { useEffect, useState } from "react";
import { Breadcrumbs } from "@truevault/aquilo";
import { useHistory, useParams } from "react-router";
import { StandardPageWrapper } from "../../../../components/layout/StandardPageWrapper";
import { PageLoading } from "../../../../components";
import { usePrimaryOrganizationId } from "../../../../hooks";
import { useCollectionGroup } from "../../../../hooks/useCollectionGroups";
import { useSurvey } from "../../../../../common/hooks/api/useSurvey";
import { UUIDString } from "../../../../../common/service/server/Types";
import { Routes } from "../../../../root/routes";
import { ProgressFooter, ProgressFooterActions } from "../../../get-compliant/ProgressFooter";
import {
  EMPLOYEE_COLLECTION_PURPOSES_SURVEY,
  EmploymentGroupPurposesQuestion,
  isHrPurposesComplete,
} from "../../../../components/organisms/collection-groups/EmploymentGroupPurposesQuestion";
import { HrPurposesExplanatoryCard } from "../../../data-map/data-flows/DataFlowsExplanatoryCards";
import { HRDataMapTabs } from "./HRDataMapTabs";

export function HRDataFlowsPurposesPage() {
  const history = useHistory();
  const orgId = usePrimaryOrganizationId();
  const { groupId } = useParams<{ groupId: UUIDString }>();
  const [group] = useCollectionGroup(orgId, groupId);
  const { answers, request: surveyRequest } = useSurvey(orgId, EMPLOYEE_COLLECTION_PURPOSES_SURVEY);

  const dashboardRoute = Routes.hrCenter.hrDataMap.dataFlows;
  const isComplete = isHrPurposesComplete(answers, group?.id);

  const [showOnboardingFooter, setShowOnboardingFooter] = useState<boolean | null>(null);
  useEffect(() => {
    if (group && surveyRequest.success && showOnboardingFooter === null) {
      setShowOnboardingFooter(!isHrPurposesComplete(answers, group.id));
    }
  }, [group, surveyRequest.success, answers, showOnboardingFooter]);

  if (!group || !surveyRequest.success) {
    return <PageLoading />;
  }

  return (
    <StandardPageWrapper
      fullWidth
      footer={
        showOnboardingFooter && (
          <ProgressFooter
            actions={
              <ProgressFooterActions
                nextContent="Done with Data Purposes"
                nextOnClick={() => history.push(dashboardRoute)}
                nextDisabled={!isComplete}
                nextDisabledTooltip="Answer the commercial purposes question to continue."
              />
            }
          />
        )
      }
    >
      <div className="tw-boundary">
        <div className="mb-[32px]">
          <Breadcrumbs
            hideHomeIcon={true}
            title={`Data Purposes - ${group.name}`}
            source="Data Flows"
            sourceRoute={dashboardRoute}
          />
        </div>
        <HRDataMapTabs selectedTabKey="hr-data-flows" />
        <div className="max-w-[800px]">
          <HrPurposesExplanatoryCard collectionGroupName={group.name} />
          <div className="mt-[24px]">
            <EmploymentGroupPurposesQuestion employeeGroup={group} />
          </div>
        </div>
      </div>
    </StandardPageWrapper>
  );
}
